import ReactDOM from 'react-dom/client'

import GroupsPerformance from './performance'
import { GroupRow } from './types'

window['FinvizInitGroupsPerformance'] = function (rows: GroupRow[]) {
  const rootEl = document.getElementById('groups')
  if (rootEl) {
    const root = ReactDOM.createRoot(rootEl)
    root.render(<GroupsPerformance rows={rows} />)
  }
}
